import React from "react"
import type { CSSProperties, ReactNode } from "react"
import styled from "~/ui/styled"
import { ImageBackground, View, ScrollView } from "~/ui/primitives"
import { StartFlex, CenterFlex, Button, IconFont } from "~components/El"

export const popupImageFillStyle: CSSProperties = {
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
}

export const PopupRoot = styled(StartFlex)`
  position: relative;
  width: 100%;
  background-color: transparent;
`

type ShellProps = {
  height?: number
  borderRadius?: number
  children: ReactNode
}

export function PopupContentShell({ height = 405, borderRadius = 16, children }: ShellProps) {
  return (
    <View
      style={{
        width: "100%",
        height,
        borderRadius,
        overflow: "hidden",
      }}
    >
      {children}
    </View>
  )
}

type ImageBgProps = ShellProps & {
  src: string
  resizeMode?: "cover" | "contain" | "stretch" | "center"
  children: ReactNode
}

export function PopupImageBackground({
  src,
  height = 405,
  borderRadius = 16,
  resizeMode = "cover",
  children,
}: ImageBgProps) {
  return (
    <PopupContentShell height={height} borderRadius={borderRadius}>
      <ImageBackground src={src} resizeMode={resizeMode} style={popupImageFillStyle}>
        {children}
      </ImageBackground>
    </PopupContentShell>
  )
}

const CloseContent = styled(CenterFlex)`
  position: absolute;
  left: 0;
  right: 0;
  bottom: -44px;
  width: 100%;
  height: auto;
`

const CloseButton = styled(Button)`
  width: 30px;
  height: 30px;
  border-radius: 15px;
  border: 1px solid #ffe6bd;
`

export function PopupClose({ onClose }: { onClose: () => void }) {
  return (
    <CloseContent>
      <CloseButton onClick={onClose}>
        <IconFont name="close" size={14} color="#ffe6bd" />
      </CloseButton>
    </CloseContent>
  )
}

export function PopupScrollArea({
  children,
  backgroundColor,
}: {
  children: ReactNode
  backgroundColor: string
}) {
  return (
    <ScrollView
      style={{
        flex: 1,
        minHeight: 0,
        width: "100%",
        padding: "4px 0",
        borderRadius: 10,
        backgroundColor,
      }}
    >
      {children}
    </ScrollView>
  )
}
